
const SECURITY_KEY = process.env.REACT_APP_SECURITY_KEY;
const themeDefault = 'dark'
const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']

const BASE_URL = process.env.REACT_APP_BASE_URL;
const STUDENT_BASE_URL = process.env.REACT_APP_STUDENT_BASE_URL;
const LCMS_API_BASE_URL = process.env.REACT_APP_LCMS_API_BASE_URL;
const GAME_PREVIEW_BASE_URL = process.env.REACT_APP_GAME_PREVIEW_BASE_URL;


// BMD (Baseline Math Diagnostics) estimated time per question.
// Per spec §4.4: 30s MCQ + 10s buffer + ~10s for 2 follow-ups = ~50 seconds.
// Change this single value to update the estimated time everywhere it's displayed
// (summary card, staged-draft sidebar, activity card).
// Keep in sync with BMD_SECONDS_PER_QUESTION_ESTIMATE in the student app.
const BMD_SECONDS_PER_QUESTION = 60

const optionCoin = [
    { label: "2", value: "2" },
    { label: "5", value: "5" },
    { label: "10", value: "10" },
    { label: "15", value: "15" },
    { label: "20", value: "20" },
    { label: "25", value: "25" },
    { label: "30", value: "30" },
  ]

export { SECURITY_KEY, themeDefault, namesOfModes, BASE_URL, STUDENT_BASE_URL, optionCoin, LCMS_API_BASE_URL, GAME_PREVIEW_BASE_URL, BMD_SECONDS_PER_QUESTION}